import React from "react";
import {Card, CardContent, CardHeader, Container} from "@mui/material";
import { object, string, number, boolean, date, coerce } from 'zod';
import {formatDateTime, formatDateTimeParam, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import * as crudgen from "../../../../share";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import { CuttingState, CuttingStatePairs, toString as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { ShipmentState, ShipmentStatePairs, toString as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { ShipmentType, ShipmentTypePairs, toString as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { UserType, UserTypePairs, toString as toStringUserType } from "../../../types/models/UserType.d";
import { CordwoodMeasurementType, CordwoodMeasurementTypePairs, toString as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";





import { PrimaryPricingProfile } from "../../../../timber/types/models/PricingProfile";

import PricingProfileFormSelect from "../../../../timber/components/pricingProfile/PricingProfileForm/PricingProfileFormSelect";



import TimberTypeFormSelect from "../../../../timber/components/timberType/TimberTypeForm/TimberTypeFormSelect";



import TimberClassFormSelect from "../../../../timber/components/timberClass/TimberClassForm/TimberClassFormSelect";



import ThicknessClassFormSelect from "../../../../timber/components/thicknessClass/ThicknessClassForm/ThicknessClassFormSelect";









import { t, msg } from "@lingui/core/macro";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import {useLocation} from "react-router";
























export const initialFormStateFn = () => { return {
    
        
        pricingProfileId: null,
        
    
        
        timberTypeId: null,
        
    
        
        classId: null,
        
    
        
        thicknessClassId: null,
        
    
        
        price: "",
        
    
    }
}

export const useLocationFormState = () => {
    const initialFormState = initialFormStateFn()
    let location = useLocation();
    initialFormState.pricingProfileId = PrimaryPricingProfile.fromQuery(location.state?.pricingProfileId) || null;
    

    

    return React.useMemo(() => initialFormState, [
        location.state,
        
        
    ])
}

export const formObject = {
    
    
        pricingProfileId:
        string()
                .nanoid(msg`Pricing Profile is required`)
                .min(1, msg`Pricing Profile is required`),
    
    
        timberTypeId:
        string()
                .nanoid(msg`Timber Type is required`)
                .min(1, msg`Timber Type is required`),
    
    
        classId:
        string()
                .nanoid(msg`Timber Class is required`)
                .min(1, msg`Timber Class is required`),
    
    
        thicknessClassId:
        string()
                .nanoid(msg`Thickness Class is required`)
                .nullish(),
    
    
        price:
        number()
                 .gt(0).transform((value) => (!value ? null : value))
                .and(coerce.number(msg`must be a number.`)),
    
};

export const formSchema = object(formObject);

const PriceAddForm = ({watch, prefix = ''})  => {
    return (
        <Container>
           
           
   
    
    <PricingProfileFormSelect
        type="dynamicSelect"
        name="pricingProfileId"
        label={t`Pricing Profile`}
        prefix={prefix}
        required={ true }
    />
   
   
   
           
           
   
    
    <TimberTypeFormSelect
        type="select"
        name="timberTypeId"
        label={t`Timber Type`}
        prefix={prefix}
        required={ true }
    />
   
   
   
           
           
   
    
    <TimberClassFormSelect
        type="select"
        name="classId"
        label={t`Timber Class`}
        prefix={prefix}
        required={ true }
    />
   
   
   
           
           
   
    
    <ThicknessClassFormSelect
        type="select"
        name="thicknessClassId"
        label={t`Thickness Class`}
        prefix={prefix}
        required={ false }
    />
   
   
   
           
           
   
   <crudgen.FormInput
       required
       name={ prefix + 'price' }
       aria-label="price"
       data-testid="price"
       label={t`Price`}
       
       type='number'
       checkNumber={true}
       forceNumber={true}
       
   />
   
   
           
        </Container>
    )
}

export default PriceAddForm;
